module.exports = __webpack_public_path__ + "img/abg3.f9141331.png";